import { Button, Modal, Row } from 'antd';
import Link from 'antd/lib/typography/Link';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface ConnectToModusignModalProps {
  visible: boolean;
  content: any;
  userEmail: string;
  registerUserToModusign: () => void;
  onCancel: () => void;
}

function ConnectToModusignModal({
  visible,
  content,
  userEmail,
  registerUserToModusign,
  onCancel,
}: ConnectToModusignModalProps) {
  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="모두싸인 연결하기"
        footer={null}
        onCancel={onCancel}
      >
        <>
          <Row justify="center">
            <h3>{content.title}</h3>
          </Row>
          <Row justify="center">
            <p style={{ whiteSpace: 'pre-wrap' }}>{content.description}</p>
          </Row>
          <Row justify="center">
            {content.isUserRegistered ? (
              // <Link
              //   to={{
              //     pathname:
              //       'https://app.modusign.co.kr/oauth/authorize?response_type=code&client_id=01FQXNFARGTB8FPE6K7B7BP9VX&state=8759367&redirect_uri=http%3A%2F%2F127.0.0.1%3A4001%2Fv1%2Fauth%2Fmodusign%2Fredirect',
              //   }}
              //   target="_blank"
              // >
              //   {content.title}
              // </Link>
              <Link
                href={`https://app.modusign.co.kr/oauth/authorize?response_type=code&client_id=${
                  process.env.REACT_APP_MODU_SIGN_CLIENT_ID
                }&state=${
                  process.env.REACT_APP_MODU_SIGN_STATE
                }/${userEmail}&redirect_uri=${encodeURI(
                  process.env.REACT_APP_API_ENDPOINT! +
                    '/auth/modusign/redirect',
                )}`}
              >
                {content.title}
              </Link>
            ) : (
              <Button onClick={registerUserToModusign}>
                {content.btnName}
              </Button>
            )}
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default ConnectToModusignModal;
